import { useCurrentStreamUser } from "./useCurrentStreamUser";

type UserAiStatus = {
  isAiEnabled: boolean;
};

export const useUserAiStatus = (): UserAiStatus => {
  const { user } = useCurrentStreamUser();
  const userData = user as { is_ai_enabled?: boolean } | undefined;

  const isAiEnabled = userData?.is_ai_enabled ?? true;

  return { isAiEnabled };
};
